export default `vec3 z,q;
    p.z -= 9.; z=p;
    float a=1.,n=.9;
    for(int j=0;j++<15;){
      p.xy*=rotate2D(float(j*j));
      a*=.66;
      q=sin(p*=1.5);
      n+=q.x*q.y*q.z*a;
    }
    return (n*.2-z.z*.2);
  }`